/* istanbul ignore file */
import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import { PolicyInfoPage, PolicyDetailsPage, OfferingsPage, LocationsPage, SuccessPage, DeclarationPage, RiskAnalysisPage } from 'premier-capability-policyjob-react';
import CodegenWizard from './CodegenWizard';
import { CodegenContext } from './components/CodegenContext';

import QuotePage from './pages/Quote/QuotePage';
import EnvEmpairmentPage from './pages/EnvImpairment/EnvEmpairmentPage'
import CoveredLocationsPage from './pages/CoveredLocations/CoveredLocationsPage'
import LiabilityCoveragesPage from './pages/Coverages/CoveragesPage'

setComponentMapOverrides(
    {

        PremierELOfferingsPage : { component: 'PremierELOfferingsPage'},
        PremierELPolicyDetailsPage: { component: 'PremierELPolicyDetailsPage' },
        PremierELLocationsPage : { component: 'PremierELLocationsPage'},
        PremierELRiskAnalysisPage: { component: 'PremierELRiskAnalysisPage' },
        PremierELQuotePage: { component: 'PremierELQuotePage' },
        PremierELPolicyInfoPage: { component: 'PremierELPolicyInfoPage' },
        PremierELDeclarationPage: { component: 'PremierELDeclarationPage' },
        PremierELSuccessPage: { component: 'PremierELSuccessPage' },
		PremierELEnvEmpairmentPage: { component: 'PremierELEnvEmpairmentPage' },
		PremierELCoveredLocationsPage: { component: 'PremierELCoveredLocationsPage' },
		PremierELLiabilityCoveragesPage: { component: 'PremierELLiabilityCoveragesPage' },
    },
    {
        PremierELOfferingsPage: OfferingsPage,
        PremierELPolicyDetailsPage: PolicyDetailsPage,
        PremierELLocationsPage: LocationsPage,
        PremierELRiskAnalysisPage: RiskAnalysisPage,
        PremierELQuotePage: QuotePage,
        PremierELPolicyInfoPage: PolicyInfoPage,
        PremierELDeclarationPage: DeclarationPage,
        PremierELSuccessPage: SuccessPage,
		PremierELEnvEmpairmentPage: EnvEmpairmentPage,
		PremierELCoveredLocationsPage: CoveredLocationsPage,
		PremierELLiabilityCoveragesPage: LiabilityCoveragesPage,
    }
);
export { CodegenWizard, CodegenContext };
